// @core/api/endpoints/document/update_pipeline.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PipelineResponse,
  UpdatePipelineRequest,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Update pipeline
 * Updates a pipeline template. Only DRAFT pipelines can have stages modified. ACTIVE pipelines can only update name/description.
 */
export async function UpdatePipeline(
  pipeline_id: string,
  data: UpdatePipelineRequest,
  options?: RequestOptions
): Promise<PipelineResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/document-pipelines/:pipeline_id`;
  requestPath = requestPath.replace(':pipeline_id', encodeURIComponent(pipeline_id));
  const requestOptions = options;
  return client.put<PipelineResponse>(requestPath, data, requestOptions);
}
